export enum OrderPositionEnum {
  BEFORE = 'before',
  AFTER = 'after',
  INSIDE = 'inside',
}
